export default __webpack_public_path__ + "images/259ff21f719cc731d6b2129301940eba-mobile.jpg";